export default __webpack_public_path__ + "static/38-50ef8e63a53c3a6740b48c39f60e4477.png";